/*!
 * Dulce Vida Tequila - Big Thirst Headless Loader
 *
 * Install this stable file once on dulcevidaspirits.com. It fetches the
 * config with a fresh query string so future product/config/engine updates
 * stay cache-safe.
 */

(function () {
  'use strict';

  if (window.__BT_DULCE_LOADER_LOADED) return;
  window.__BT_DULCE_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://dulce-vida-tequila.myshopify.com/cdn/shop/files/dulce-config.js';
  var configSrc = window.__BT_DULCE_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_DULCE_CONFIG_VERSION_OVERRIDE || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-dulce-config', 'true');
  head.appendChild(script);
})();
